<template>
    <span>
        <similarity-indicator
            v-if="showSimilarityIndicator && similarityScore"
            :similarity-score="similarityScore"
            :threshold="threshold"
            :very-similar-percentage="verySimilarPercentage"
            :somewhat-similar-offset="somewhatSimilarOffset"
        >
            <template v-slot:value1>
                <span v-if="['partial', 'full'].includes(highlightMode) && similarityLevel === SimilarityLevel.DIFFERENT">{{ string1 }}</span>
                <Diff
                    v-else
                    :string1="string1"
                    :string2="string2"
                    mode="highlight"
                    hide-parts="ins"
                />
            </template>
            <template v-slot:value2>
                <span v-if="['partial', 'full'].includes(highlightMode) && similarityLevel === SimilarityLevel.DIFFERENT">{{ string2 }}</span>
                <Diff
                    v-else
                    :string1="string2"
                    :string2="string1"
                    mode="highlight"
                    hide-parts="ins"
                />
            </template>
        </similarity-indicator>

        <mark v-if="['partial', 'full'].includes(highlightMode) && similarityLevel === SimilarityLevel.DIFFERENT">{{ string1 }}</mark>
        <Diff
            v-else
            :string1="string1"
            :string2="string2"
            mode="highlight"
            hide-parts="ins"
        />
    </span>
</template>

<script>
import { SimilarityLevel } from '@/enums'
import { DEFAULT_SIMILARITY_OPTIONS } from '@/helpers/similarity'
import Diff from '@/components/Diff.vue'
import SimilarityIndicator from '@/components/SimilarityIndicator.vue'

export default {
    name: 'SimilarityStringDiff',
    components: { SimilarityIndicator, Diff },
    props: {
        string1: {
            type: String,
            required: true,
        },
        string2: {
            type: String,
            required: true,
        },
        similarityScore: {
            type: [String, Number],
            default: 0,
        },
        similarityLevel: {
            type: String,
            default: '',
            validator: (value) => Object.values(SimilarityLevel).includes(value),
        },
        highlightMode: {
            type: String,
            default: 'diff',
            validator: (value) => ['full', 'partial', 'diff', 'none'].includes(value),
        },
        showSimilarityIndicator: {
            type: Boolean,
            default: true,
        },

        threshold: {
            type: Number,
            default: DEFAULT_SIMILARITY_OPTIONS.threshold,
            validator: (value) => value >= 0 && value <= 1,
        },
        verySimilarPercentage: {
            type: Number,
            default: DEFAULT_SIMILARITY_OPTIONS.verySimilarPercentage,
            validator: (value) => value >= 0 && value <= 100,
        },
        somewhatSimilarOffset: {
            type: Number,
            default: DEFAULT_SIMILARITY_OPTIONS.somewhatSimilarOffset,
            validator: (value) => value >= 0 && value <= 1,
        },

    },
    setup (props) {
        return {
            SimilarityLevel,
        }
    },
}
</script>
